import React, { useEffect, useState } from "react";
// import API from '../Services/AddPackage'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import moment from "moment";
import LocationList from "./Location";
import API from '../Services/PartyProduct'
import CenterModal from "./CenterModal";


const ActivityTypeList = () => {
    const [activityTypeList, setActivityTypeList] = useState([])
    const [error, setError] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [id, setId] = useState(null)
    const [status, setStatus] = useState("");
    const limit = 10;
    const [name, setName] = useState("");
    const [logoPreview, setLogoPreview] = useState(null);
    const [type, setType] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [locationId, setLocationId] = useState("");
    const [activityTypeName, setActivityTypeName] = useState("");
    const [activityTypeDisplayName, setActivityTypeDisplayName] = useState("");
    const [activityName, setActivityName] = useState("");
    const [playPoint, setPlayPoint] = useState("");
    const [amount, setAmount] = useState("");
    const [image, setImage] = useState(null);
    const [centerName, setCenterName] = useState("")
    const [selectedCenter, setSelectedCenter] = useState([]);
    const [allDaysChecked, setAllDaysChecked] = useState(false);
    const [weekList, setWeekList] = useState("");
    useEffect(() => {
        getActivityList()
    }, [currentPage]);

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        //  console.log("value data....", value)
        switch (fieldName) {
            case "activityTypeName":
                setActivityTypeName(value);
                break;
            // case "activityTypeDisplayName":
            //     setActivityTypeDisplayName(value);
            //     break;
            case "activityName":
                setActivityName(value);
                break;
            case "amount":
                setAmount(value);
                break;
            case "playPoint":
                setPlayPoint(value);
                break;
            default:
                break;
        }
    }


    const validateFields = () => {
        const newErrors = {};

        if (!activityTypeName.trim()) error.activityTypeName = "Name is required";
        // if (!activityTypeDisplayName.trim()) error.activityTypeDisplayName = "Display Name is required";
        if (!image) error.icon = "Image is required";
        //if (!image) newErrors.image = "Image is required.";

        setError(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleLogoChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const allowedFormats = ['image/png'];
            const maxSize = 5 * 1024 * 1024;
            if (!allowedFormats.includes(file.type)) {
                toast.error("Only PNG formats are allowed.")
                event.target.value = '';
                return;
            }
            if (file.size > maxSize) {
                toast.error("File size must be 5MB or smaller.")
                event.target.value = '';
                return;
            }
            setImage(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };



    const getActivityList = async () => {
        try {
            const response = await API.getActivityTypeList({
                page: currentPage,
                limit: 10,

            });

            setActivityTypeList(response?.data?.data || []);
            setTotalRecords(response?.data?.totalItems)
        } catch (error) {
            setError((prevErrors) => ({
                ...prevErrors,
                duration: "Failed to fetch activity type data.",
            }));
            handleError(error);
        }
    };

    const handleError = (error) => {
      //  console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const totalPages = Math.ceil(totalRecords / limit);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);

        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    }

    const handleGetData = async (id) => {
        // console.log("id....", id)
        try {
            const response = await API.getActivityTypeList({ id: id });
            const fetchedData = response?.data?.data?.[0];
            // console.log('ffffff', fetchedData);

            if (fetchedData) {
                setId(fetchedData.id);
                setLocationId(fetchedData?.location_id)
                setActivityTypeName(fetchedData?.name)
                // setActivityTypeDisplayName(fetchedData?.display_name)
                setAmount(fetchedData?.amount);
                setStatus(fetchedData?.is_active);
                setCreatedAt(fetchedData?.createdAt);
                setLogoPreview(fetchedData?.icon)
                setCenterName(fetchedData?.location_name)
                // setWeekList(fetchedData?.week_list)

                let weekdaysObject = {};
                const weekdaysArray = fetchedData?.week_list
                    ? fetchedData?.week_list.split(",").map(day => day.trim())
                    : [];

                if (weekdaysArray.includes("All Days")) {
                    // All checkboxes true
                    weekdaysObject = allWeekdays.reduce((acc, day) => {
                        acc[day] = true;
                        return acc;
                    }, {});
                } else {
                    weekdaysObject = allWeekdays.reduce((acc, day) => {
                        acc[day] = weekdaysArray.includes(day);
                        return acc;
                    }, {});
                }

                setWeekdays(weekdaysObject);

            } else {
                toast.error("Failed to fetch  details.");
            }
        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const updateActivityList = async () => {
        //    if (!validateFields()) return;
        const selectedDaysArr = Object.keys(weekdays).filter(day => weekdays[day]);
        const weekList = selectedDaysArr.length === 7 ? "All Days" : selectedDaysArr.join(", ");

      //  console.log('weekList', selectedDaysArr);

        if (!Array.isArray(selectedDaysArr) || selectedDaysArr.length === 0) {
            toast.error("Please select at least one weekday.");
            return;
        }
        //  return 
        const formData = new FormData();
        formData.append("location_id", parseInt(locationId));
        formData.append("name", activityTypeName);
        formData.append("week_list", weekList);
        // formData.append("icon", amount);
        // formData.append("display_name", activityTypeDisplayName);
        if (image instanceof File) {
            formData.append("icon", image);
        }
        try {
            const response = await API.updateActivityType(id, formData);
            // console.log("response data......", response?.data?.message)
            if (response?.status === 200) {
                toast.success(response?.data?.message || "Add-on Activity Type successfully!");
                getActivityList()
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update Activity Type.");
            }
        } catch (error) {
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            }
            toast.error(error.message);
        }
    };

    const handleUpdate = async () => {
        if (!validateFields()) return;
        await updateActivityList();
    };
    const handleGetLogo = (logo) => {
        // console.log("logo data...", logo)
        setImage(logo)
    }
    const changeStatus = async (id, currentStatus) => {

        const updatedStatus = !currentStatus;
        try {
            const response = await API.changeActivityTypeStatus(id, updatedStatus);
            if (response.status === 200) {
                setActivityTypeList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Activity Type ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
                getActivityList();
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            toast.error("Failed to update the status. Please try again.");
        }
    };

    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };

    const allWeekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    const handleAllDaysToggle = () => {
        const newState = !allDaysChecked;
        const updatedWeekdays = {};
        allWeekdays.forEach(day => {
            updatedWeekdays[day] = newState;
        });
        setWeekdays(updatedWeekdays);
        setAllDaysChecked(newState);
    };
    const handleWeekdayChange1 = (day) => {
        const updated = {
            ...weekdays,
            [day]: !weekdays[day],
        };
        setWeekdays(updated);

        // Update "All Days" checkbox status
        const allSelected = allWeekdays.every(d => updated[d]);
        setAllDaysChecked(allSelected);
    };
    const [weekdays, setWeekdays] = useState({
        Sunday: false,
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
    });

    return (
        <div>

            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added Activity Type</h4>
                    </div>
                    <div className="card-body">
                        {/* <div className="row mb-3">
                            <div className="col-md-4">
                                <CenterModal onSelectCenter={handleSelectedCenter} />
                            </div>
                            <div className="col-md-3">
                                <label></label>
                                <button
                                    type="button"
                                    className="btn btn-success mt-3"
                                >Search</button>
                            </div>
                        </div> */}

                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Name</th>
                                        <th>Center Name</th>
                                        <th>Week List</th>
                                        {/* <th>Display Name</th> */}
                                        <th>Status</th>
                                        <th>Created-Date</th>
                                        <th>Icon</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {activityTypeList && activityTypeList.length > 0 ? (
                                        activityTypeList.map((item, index) => (

                                            <tr key={item?.id || index} data-active={item?.is_active ? "true" : "false"}>
                                                <td>{(currentPage - 1) * limit + index + 1}</td>
                                                <td>
                                                    <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                        <ul className="navbar-nav navbar-nav-right">
                                                            <li className="nav-item nav-profile1">
                                                                <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <div className="nav-profile-text1">
                                                                        <p className="mb-1 text-black">
                                                                        </p>
                                                                    </div>
                                                                </span>
                                                                <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                                <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                    <a className="dropdown-item">
                                                                        <button onClick={() => handleGetData(item?.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalActivityList">
                                                                            View
                                                                        </button>
                                                                    </a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a className="dropdown-item">
                                                                        <button onClick={() => handleGetData(item?.id)}
                                                                            className="btn btn-primary btn-sm" type="button"
                                                                            data-bs-toggle="modal" data-bs-target="#myModal"
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                    </a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a className="dropdown-item">

                                                                        <button
                                                                            className={`btn btn-sm ${item?.is_active ? "btn-secondary" : "btn-info"}`}
                                                                            onClick={() => changeStatus(item?.id, item?.is_active)}
                                                                        >
                                                                            {item?.is_active ? "De-Activate" : "Activate"}
                                                                        </button>

                                                                    </a>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td>{item?.name}</td>
                                                <td>{item?.location_name}</td>
                                                <td>{item?.week_list}</td>
                                                <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                                <td>{moment(item?.createdAt).format("DD-MM-YYYY")}</td>
                                                <td>
                                                    {item.icon && item.icon.trim() !== "" ? (
                                                        <button onClick={() => handleGetLogo(item.icon)}
                                                            className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModallogo">
                                                            View
                                                        </button>
                                                    ) : "N/A"}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9">No Record found.</td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}

                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                </div>
            </div>

            <section>
                <div className="modal" id="myModalActivityList">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Activity Type</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">

                                <table className="table table-bordered border-secondary">
                                    <thead>
                                        <tr>

                                            <th>Center name</th>
                                            <th>Name</th>
                                            {/* <th>Display name</th> */}
                                            <th>Status</th>

                                        </tr>
                                        <tr>
                                            <td>{centerName}</td>

                                            <td>{activityTypeName}</td>
                                            {/* <td>{activityTypeDisplayName}</td> */}
                                            <td>{status ? "Active" : "De-Activated"}</td>


                                        </tr>

                                        <tr>
                                            <td>Week Day List</td>
                                            <td>Icon</td>
                                            <th>Created Date</th>

                                        </tr>
                                        <tr>
                                            <td>
                                                {weekdays === "All Days"
                                                    ? "All Days"
                                                    : Object.entries(weekdays)
                                                        .filter(([day, isSelected]) => isSelected)
                                                        .map(([day]) => day)
                                                        .join(', ') || 'All Days'}
                                            </td>
                                            <td>
                                                {logoPreview ? (
                                                    <img
                                                        src={logoPreview}
                                                        alt="Image"
                                                        width="50"
                                                        height="50"

                                                    />
                                                ) : (
                                                    <span>No Image Available</span>
                                                )}
                                                {/* <img src={logoPreview || 'No Image Available'} alt="Image" />
                                             */}
                                            </td>
                                            <td colSpan={2}>{moment(createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className="modal-footer">

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModal" data-bs-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update Activity Type</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <LocationList
                                            selectedLocation={locationId}
                                            label="Center Name"
                                            isRequired={false}
                                            disabled={true}
                                            setSelectedLocation={(location) => setLocationId(location)}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label>Name <span className="text-danger">*</span></label>
                                        <input
                                            className="form-control"
                                            placeholder="Name"
                                            value={activityTypeName}
                                            onChange={(e) => handleFieldChange(e, "activityTypeName")}
                                        />
                                        {error.activityTypeName && <small className="text-danger">{error.activityTypeName}</small>}
                                    </div>
                                </div>

                                <div className="row mt-1">
                                    <div className="col-md-12">
                                        <label>Weekday List (All Days)
                                            <input
                                                type="checkbox"
                                                checked={allDaysChecked}
                                                onChange={handleAllDaysToggle}
                                                className="form-check-input ms-3"
                                                style={{ border: '2px solid black' }}
                                            /></label>
                                        <div className="d-flex flex-wrap">
                                            {allWeekdays.map((day) => (
                                                <div className="form-check me-3" key={day}>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input ms-1"
                                                        id={day}
                                                        checked={weekdays[day] || false}
                                                        onChange={() => handleWeekdayChange1(day)}
                                                    />
                                                    <label htmlFor={day} className="form-check-label">{day}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-4">
                                        <label>Upload Image <span className="text-danger">*</span></label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept="image/png, image/gif, image/jpeg"
                                            onChange={handleLogoChange}
                                        />
                                        {error.image && <span className="text-danger">{error.image}</span>}
                                    </div>

                                    <div className="col-md-4">
                                        {logoPreview && (
                                            <img
                                                src={logoPreview || 'No Image Available'}
                                                alt="Preview"
                                                style={{ width: 100, height: 100, objectFit: "cover", marginTop: 10 }}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary" type="button" onClick={handleUpdate} >Update</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModallogo">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Icon</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row my-3" style={{ justifyContent: "center" }}>
                                    <img src={image || 'No Image Available'} alt="Logo" style={{ "width": "200px", "height": "150px" }} />
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    );
};

export default ActivityTypeList;